import request from '@/router/axios'
import env from '@/config/env'

// 列表
export function postPage(data) {
  return request({
    url: env.ferryUrl + '/activity-redemption/page',
    method: 'post',
    data
  })
}

// 保存
export function saveOrUpdate(data) {
  return request({
    url: env.ferryUrl + '/activity-redemption/saveOrUpdate',
    method: 'post',
    data
  })
}

// 详情
export function getDetail(id) {
  return request({
    url: env.ferryUrl + `/activity-redemption/detail/${id}`,
    method: 'get'
  })
}

// 兑换数据汇总
export function getDataSummary(id) {
  return request({
    url: env.ferryUrl + `/activity-redemption/data-summary/${id}`,
    method: 'get'
  })
}

// 兑换数据明细
export function postDataSummaryPage(data) {
  return request({
    url: env.ferryUrl + '/activity-redemption/data-summary-page',
    method: 'post',
    data
  })
}

// 作废恢复
export function postCancelOrRestore(data) {
  return request({
    url: env.ferryUrl + '/activity-redemption/cancel-or-restore',
    method: 'post',
    data
  })
}

// 下载
export function postDownload(data) {
  return request({
    url: env.ferryUrl + '/activity-redemption/download',
    method: 'post',
    data
  })
}
